module.exports = __webpack_public_path__ + "img/new_age_feature_01.4dc509ab.jpg";